var appThis
/**
 * calType 0是酒店多选  1是单选
 */
var calType
// 固定的组装数据
var initialData = {
  // 日历组件
  count: 3, //设置显示多少个月
  today: 0,
  initStart: '',
  initEnd: '',
  start: '',
  end: '',
  priceStock: '',
  date: '',
  firstDate: '', //酒店专用第一天
  optionId: 0,
  months: [],
  dates: [],
  classNames: {
    begin: 'begin',
    start: 'start',
    enable: 'enable',
    today: 'today',
    select: 'selected',
    priceStock: '',
    price: ''
  },
  festivaltag: {
    '1-1': '1',
    '2-14': '14',
    '3-8': '8',
    '5-1': '1',
    '6-1': '1',
    '7-1': '1',
    '8-1': '1',
    '10-1': '1',
    '12-24': '24',
    '12-25': '25'
  },
  selectedDate: '',
  // 价格和库存表
  list: [],
  scrollViewHeight: 667, //scroll-view默认高度
  activeIndex: 0,
  order: {} //自由行需要的
}

export function getDateData(data) {
  return data
}


/**
 * 页面启动传值
 */
export function claLoad(that) {
  appThis = that
  calType = appThis.data.calType
  //传入必要的数据
  initialData.list = transformDataList(appThis.data.list)
  console.log('list', initialData.list)
  initialData.selectedDate = appThis.data.selectedDate
  initialData.order = appThis.data.order
  initialData.count = appThis.data.count
  initialData.priceStock = appThis.data.priceStock
  initialData.start = appThis.data.start
  initialData.end = appThis.data.end
  initialData.firstDate = appThis.data.firstDate
  initialData.optionId = appThis.data.optionId //增加酒店房型ID
  initialData.activeIndex = appThis.data.activeIndex
  appThis.data = initialData
  console.log('data', appThis.data)
  var today = appThis.data.today ? new Date(appThis.data.today) : new Date()
  console.log(today)
  var initStart = initStartDay(appThis.data.begin, today)
  var start = initStartDay(appThis.data.begin, today)
  console.log('start', start)
  var initEnd = initEndDay(appThis.data.end, today)
  var end = initEndDay(appThis.data.end, today)
  var date = (function(start, index) {
    var begin = new Date(Math.min(start, new Date()))
    // return new Date(begin.getFullYear(), begin.getMonth() + 1, 0)
    if (calType == 1) {
      return new Date(appThis.data.start)
    } else {
      return new Date(appThis.data.firstDate)
    }

  })(appThis.data.start || start)
  var dates = []
  var months = []

  // 设置整点
  today.setHours(0)
  today.setMinutes(0)
  today.setSeconds(0)
  today.setMilliseconds(0)
  // setData
  // appThis.setData({
  //   today: today,
  //   initStart: initStart,
  //   initEnd: initEnd,
  //   start: start,
  //   end: end,
  //   date: date
  // });
  // 生成对应的count个月的数据model
  for (var i = 0; i < appThis.data.count; i++) {

    var _newDate = new Date(date.getFullYear(), date.getMonth() + i, 1)
    var month = _newDate.getMonth() + 1
    console.log(month)
    month = month > 9 ? month : '0' + month
    months.push(_newDate.getFullYear() + '-' + month)
    dates.push(createDate(_newDate))
  }

  appThis.data.month = months
  console.log(appThis.data.month)
  appThis.data.dates = dates
  console.log(dates)
  console.log(months)
  // appThis.setData({
  //   dates: dates,
  //   months: months
  // });

}

/**
 * 初始化日期
 */
function initStartDay(start, today) {
  if (typeof (start) == 'string') {
    start = start.replace(/-/g, '/')
    // 一般用于格式化日期,如2016 - 1 - 1 格式化为2016 / 1 / 1
  }
  if (start) {
    return new Date(start)
  }
  var n = new Date(today)
  var t = n.getHours()
  if (t >= 0 && t <= 5) {
    n.setDate(n.getDate() - 1)
  }
  n.setHours(0)
  n.setMinutes(0)
  n.setSeconds(0)
  n.setMilliseconds(0)
  return n
}

function initEndDay(end, today) {
  if (typeof (end) == 'string') {
    end = end.replace(/-/g, '/')
  }
  if (end) {
    return new Date(end)
  }
  var n = new Date(today)
  var t = n.getHours() // 可取得当前时间的小时
  if (!(t >= 0 && t <= 5)) {
    // setDate() 方法用于设置一个月的某一天
    n.setDate(n.getDate() + 1)
  }
  n.setHours(0)
  n.setMinutes(0)
  n.setSeconds(0)
  n.setMilliseconds(0)
  return n
}

/**
 * 点击逻辑
 */
export function select(e) {
  console.log(e)
  var day = e.value
  var value = e.day
  // var day = e.target.dataset.value;
  // var value = e.target.dataset.day;
  console.log(e)
  //return;

  if (!value) {
    return
  }

  var start = appThis.data.start
  var end = appThis.data.end
  var valueDate = new Date(value).getTime()
  // console.log('刘毅', appThis.data)
  var today = Math.min(new Date(appThis.data.start).getTime(), new Date().getTime())
  // var today=new Date().getTime();
  var d = Math.round(((valueDate - today) / (86400000)))
  var endd = Math.round(((valueDate - new Date(start).getTime()) / (86400000))) + 1
  // if (d < 0 && !isLateMightModel(valueDate)) {

  //   return;
  // }
  if (d < 0) {

    return
  }
  var priceStock = e.priceStock
  console.log(priceStock)
  if (calType == 1) {
    if (priceStock > 0) {
      appThis.data.start = new Date(value)
      appThis.data.end = appThis.data.end
      appThis.data.price = e.price
      appThis.data.kidprice = e.kidprice
      appThis.data.redeemNum = e.redeemNum
      appThis.data.selectedDate = e.day
      appThis.data.priceStock = e.priceStock
      onChange(value, valueDate, null)
    } else if (appThis.catalogId == 3) {
      appThis.data.selectedDate = e.day
      onChange(value, valueDate, null)
    } else if (appThis.catalogId == 4) {
      appThis.data.selectedDate = e.day
      onChange(value, valueDate, null)
    }
    return
  } else {
    //如果没有房型ID就可以点击,有房型ID但没有库存不能点击(暂时取消)
    // if(appThis.data.optionId>0){
    //   if(!priceStock&&end){
    //     return;
    //   }
    // }

    if (appThis.data.start && +valueDate == +appThis.data.start && !appThis.data.end) {
      appThis.data.start = null
      appThis.data.end = null
      onChange(value, null, null)
      return
    }
    // //开始日期小于开始日期
    if (valueDate < appThis.data.start && !appThis.data.end) {
      appThis.data.start = new Date(value)
      appThis.data.end = null
      onChange(value, valueDate, null)
      return
    }
    //不能大于20天
    if (appThis.data.start && appThis.data.end == null && endd > 20) {
      // return pageUtils.toast("选择入住和离店间隔大于二十天");
      return alert('选择入住和离店间隔大于二十天')
    }
    //不能入离同天
    if (appThis.data.start && getDateString(value, '-') == getDateString(appThis.data.start, '-') && !appThis.data.end) {
      return
    }
    if (start && end) {
      appThis.data.start = new Date(value)
      appThis.data.end = null
      onChange(value, appThis.data.start, null)
      return
    }
    if (start && !end) {
      appThis.data.start = new Date(start)
      appThis.data.end = new Date(value)
      checkStock(value, appThis.data.start, appThis.data.end)
      return
    }

    if (!start && !end) {

      appThis.data.start = new Date(value)
      appThis.data.end = null
      onChange(value, appThis.data.start, appThis.data.end)
      return
    }

  }
}

function checkStock(value, start, end) {
  console.log('start', formatFullDate(new Date(start), true))
  console.log(value)
  //离店日期日期减一天
  let dateTime = new Date(value).setDate(new Date(value).getDate() - 1)
  console.log(formatFullDate(new Date(dateTime), true))
  //获取酒店所有选取的价格日期
  let daylsit = getAll(formatFullDate(new Date(start), true), formatFullDate(new Date(dateTime), true))
  console.log(daylsit)
  let allDayList = []
  var dates = appThis.data.dates
  //获取所有有库存的的日期
  dates.map(function(items, i1) {
    items.map(function(item, i2) {
      if (item.priceStock != '' && item.priceStock > 0) {
        allDayList.push(item.day)
      }
    })
  })
  console.log(allDayList)
  let dayStr = allDayList.join(',')
  let newArr = []
  daylsit.forEach(function(item) {
    if (dayStr.indexOf(item) != -1) {
      newArr.push(item)
    }
  })
  console.log(newArr)
  //选中日期比较
  if (appThis.data.optionId > 0) {
    if (daylsit.length == newArr.length) {
      onChange(value, start, end)
    } else {
      alert('选择日期里有房间没有库存！')
      return
    }
  } else {
    onChange(value, start, end)
  }

}

/**
 * 获取当前屏幕的高度
 */
export function setScrollViewHeight() {
  wx.getSystemInfo({
    success: function(data) {
      // appThis.setData({
      //   scrollViewHeight: data.windowHeight,
      // });
    }.bind(appThis)
  })
}

/**
 *  点击完重组整个数据结构
 */
function onChange(value, start, end) {

  var dates = appThis.data.dates
  dates.map(function(items, i1) {
    items.map(function(item, i2) {
      var c = getItemClass(item.day, item.day.split('-')[2], start, end, item.priceStock)
      item.classNames = c
      if (calType == 1) {
        item.txt = ''
      } else {
        item.txt = +appThis.data.start == +new Date(item.day) ? '入住' : +appThis.data.end == +new Date(item.day) ? '离店' : ''
      }

    })
  })

  appThis.data.dates = dates
  if (calType == 1) {
    appThis.callBack()
  } else {
    if (appThis.data.start && appThis.data.end) {
      appThis.callBack()
    }
  }


}

/**
 * 获取当前day的title
 */
function getShowDate(index, day) {
  var txt = new Date(day)
  if (!txt) {
    return
  }
  // if (isLateMightModel(txt)) {
  //   return '深夜';
  // }
  var festival = getFestivaltag([txt.getFullYear(), txt.getMonth() + 1, txt.getDate()].join('-'))
  // var today = Math.min(new Date(appThis.data.start).getTime(), appThis.data.today)
  var today = new Date().getTime()
  var d = Math.round(((new Date(day + ' 00:00:00') - today) / (86400000)))
  if (getDateString(appThis.data.start) == getDateString(new Date(day))) {
    return txt.getDate()
  }
  if (getDateString(appThis.data.end) == getDateString(new Date(day))) {
    return txt.getDate()
  }
  // if (parseInt(d) == 0) {
  //   return "今天";
  // }
  return festival || txt.getDate()
}

/**
 * 日期改造方法
 */
function getDateString(date, split) {
  if (typeof (date) == 'string') {
    date = new Date(date)
  }
  split = split || '-'
  var month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  var monthDay = date.getDate()
  monthDay = monthDay > 9 ? monthDay : '0' + monthDay
  var tempArr = [date.getFullYear(), month, monthDay]
  return tempArr.join(split)
}

function getDay(tempDate, tempDateStr, day) {
  var fest = appThis.data.festivaltag[tempDateStr] || ''
  var select = appThis.data.select
  var ret = ''
  ret = day
  return ret
}

function getFestivaltag(date) {
  var md = [date.split('-')[1], date.split('-')[2]].join('-')
  return appThis.data.festivaltag[md]
}

/**
 * 填充每个item的数据
 */
function getItemClass(day, value, start, end, priceStock) {
  if (!day) {
    return
  }
  var date = new Date(day)
  var strDate = [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')
  var festival = getFestivaltag(strDate)
  // var today = Math.min((new Date(appThis.data.start).getTime() || new Date().getTime()), new Date(appThis.data.today).getTime())
  var today = new Date().getTime()

  var d = Math.round(((date.getTime() - today) / (86400000)))
  var _start = new Date(start)
  var _end = new Date(end)
  var clsArr = []
  var day = date.getDay()
  if (calType == 1) {
    // if (d >= 0 || isLateMightModel(date)) {
    //   if (priceStock > 0) {
    //     clsArr.push(appThis.data.classNames.enable);
    //   } else {
    //     clsArr.push("unable");
    //   }
    // } else {
    //   clsArr.push("unable");
    // }
    console.log(appThis.catalogId)
    if (d >= 0) {
      if (priceStock > 0) {
        clsArr.push(appThis.data.classNames.enable)
        //签证
      } else if (appThis.catalogId == 3) {
        clsArr.push(appThis.data.classNames.enable)
      } else if (appThis.catalogId == 4) {//景酒
        clsArr.push(appThis.data.classNames.enable)
      } else {
        clsArr.push('unable')
      }
    } else {
      clsArr.push('unable')
    }

  } else {
    // if (d >= 0 || isLateMightModel(date)) {
    //   clsArr.push(appThis.data.classNames.enable);
    // } else {
    //   clsArr.push("enable");
    // }
    if (d >= 0) {
      // clsArr.push(appThis.data.classNames.enable);
      if (appThis.data.optionId > 0) {
        if (priceStock > 0) {
          clsArr.push(appThis.data.classNames.enable)
        } else {
          clsArr.push('unable')
        }
      } else {
        clsArr.push(appThis.data.classNames.enable)
      }

    } else {
      clsArr.push('unable')
    }
  }


  if (d == 0) {
    clsArr.push(appThis.data.classNames.today)
    //push() 方法可向数组的末尾添加一个或多个元素
  }
  //添加库存
  clsArr.push(priceStock)

  if (getDateString(date) == getDateString(_start)) {
    // 这里判断有无结束日期
    if (getDateString(_end) == '1970-01-01') {
      //把属性设置为begin
      clsArr = [appThis.data.classNames.begin]
    } else {
      if (calType == 1) {
        clsArr = [appThis.data.classNames.begin]
      } else {
        clsArr = [appThis.data.classNames.start]
      }

    }
  }
  if (calType == 0) {

    //判断在开始和结束之间
    if ((date > _start && date < _end)) {
      if (getDateString(date) != getDateString(_start)) {
        clsArr = ['range']
      }

    }
    if (value && start && getDateString(date) == getDateString(_end)) {
      clsArr = ['end']
    }
  }
  var temp = value ? clsArr.join(' ') : ''
  //join() 方法用于把数组中的所有元素放入一个字符串。元素是通过指定的分隔符进行分隔的。
  return value ? clsArr.join(' ') : ''
}

/**
 * 生成每月的数据model
 */
export function createDate(date) {
  var returnValue = []
  var day = date.getDate()

  var beginDay = new Date(date.getFullYear(), date.getMonth(), 1).getDay()
  var nDays = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  var pushObj = {
    day: '',
    value: '',
    showDay: '',
    isLastLine: ''
  }
  var len = 43 - (42 - nDays - beginDay)
  for (var i = 1; i < len; i++) {
    var tempDate = new Date(date.getFullYear(), date.getMonth(), (i - beginDay), 0, 0, 0)
    var tempDateStr = getDateString(tempDate)
    var price = ''
    var priceStock = ''
    var kidPrice = ''
    var redeemNum = ''
    //检出价格和和库存
    for (var item of appThis.data.list) {
      if (item.day == tempDateStr) {
        price = item.price
        priceStock = item.priceStock
        kidPrice = item.kidPrice
        redeemNum = item.redeemNum
      }

      // 当有选择日期的时候需要更新order
      if (item.day == appThis.data.selectedDate) {
        var order = appThis.data.order
        order.price = item.price
        order.kidPrice = item.kidPrice
        order.redeemNum = item.redeemNum
        if (item.priceStock > 0) {
          // appThis.setData({
          //   price: item.price,
          //   kidprice: item.kidPrice,
          //   priceStock: item.priceStock,
          //   order: order,
          // })
          // appThis.data.order.price=item.price;
        } else {
          // appThis.setData({
          //   selectedDate:"",
          // })
          appThis.data.selectedDate = ''
        }
      }

    }

    //定位最后一行的日期
    var lastLineDay = (nDays + beginDay) % 7
    var lastLineInitDay
    if (lastLineDay == 0) {
      // 当最后一行为一整行时
      lastLineInitDay = nDays + beginDay - 7
    } else {
      lastLineInitDay = nDays + beginDay - lastLineDay
    }
    var isLastLine = 'false'
    if (i > beginDay && i <= nDays + beginDay) {
      var _day = getDay(tempDate, tempDateStr, i - beginDay)
      // 单选时不需要填写end
      var _class
      if (calType == 1) {
        _class = getItemClass(tempDateStr, _day, appThis.data.selectedDate, appThis.data.end, priceStock)
      } else {
        _class = getItemClass(tempDateStr, _day, appThis.data.start, appThis.data.end, priceStock)

      }
      if (i > lastLineInitDay) {
        isLastLine = 'true'
      }
      var itemBottomText
      if (calType == 1) {
        itemBottomText = ''
      } else {
        var showText
        if (getDateString(appThis.data.start) == getDateString(new Date(tempDateStr))) {
          showText = '入住'
        } else if (getDateString(appThis.data.end) == getDateString(new Date(tempDateStr))) {
          showText = '离店'
        } else {
          showText = ''
        }
        itemBottomText = showText
      }
      pushObj = {
        day: tempDateStr,
        value: _day,
        showDay: getShowDate(i, tempDateStr),
        classNames: _class,
        txt: itemBottomText,
        price: price,
        kidPrice: kidPrice,
        priceStock: priceStock,
        isLastLine: isLastLine,
        redeemNum: redeemNum
      }
    }
    returnValue.push(pushObj)
  }
  console.log(returnValue)
  return returnValue
}

/**
 *  判断昨晚
 */
function isLateMightModel(target) {
  var time = new Date()
  var t = time.getHours()
  return (t < 5 && (+target + 86400000) == +appThis.data.today)
}

/**
 *  组装自己的价格model
 */
function transformDataList(initialDataList) {
  var priceList = []
  for (var i = 0; i < initialDataList.length; i++) {
    var item = initialDataList[i]
    var price = item.proPrice
    var kidPrice = item.proChildPrice
    var priceStock = item.priceStock
    var day = item.priceDate
    var redeemNum = item.redeemNum
    var priceItem = {
      day: day,
      priceStock: priceStock,
      price: price,
      kidPrice: kidPrice,
      redeemNum: redeemNum
    }
    priceList.push(priceItem)
  }
  return priceList

}
// var calendar= {
//   claLoad,
//   select,
//   setScrollViewHeight,
//   createDate,
// }
// export default calendar

function formatFullDate(date, includeYear) {
  var mDate = date.getDate()
  var month = date.getMonth() + 1
  var monthDay = date.getDate()
  var ts = (month > 9 ? month : '0' + month) + '-' + (monthDay > 9 ? monthDay : '0' + monthDay)
  if (includeYear) {
    return date.getFullYear() + '-' + ts
  }
  return ts
}

Date.prototype.format = function() {
  var s = ''
  var mouth = (this.getMonth() + 1) >= 10 ? (this.getMonth() + 1) : ('0' + (this.getMonth() + 1))
  var day = this.getDate() >= 10 ? this.getDate() : ('0' + this.getDate())
  s += this.getFullYear() + '-' // 获取年份。
  s += mouth + '-' // 获取月份。
  s += day // 获取日。
  return (s) // 返回日期。
}

function getAll(begin, end) {
  var arr = []
  var ab = begin.split('-')
  var ae = end.split('-')
  var db = new Date()
  db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
  var de = new Date()
  de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
  var unixDb = db.getTime()
  var unixDe = de.getTime()
  for (var k = unixDb; k <= unixDe;) {
    arr.push((new Date(parseInt(k))).format())
    k = k + 24 * 60 * 60 * 1000
  }
  console.log(arr)
  return arr
}